import { Controller } from '@hotwired/stimulus';
import { IStaticMethods } from 'preline/preline';
import HSSelect from '@preline/select';

export default class extends Controller {
  static targets = ['input'];

  inputTargetConnected(el) {
    window.HSStaticMethods.autoInit();
    this.instance = new HSSelect(el);
  }

  disconnect() {
    this.instance?.destroy();
  }
}
